<!-- Page Header End -->
<app-pageheader [pageOptions]="pageOptions"></app-pageheader>
<!-- Page Header End -->

<!-- Page content start -->
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="container">
    <div *ngFor="let item of RADIO_DATA">
      <h3 class="mb-4">{{ item.title[this.language] }}</h3>
      <app-youtube-player [videoID]="item.videoUrl"></app-youtube-player>
      <br /><br /><br />
    </div>
  </div>
</div>
<!-- Page content end -->
